var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center mt-1"},[_vm._v(" Welcome to Assemble Sports ")])
}
var staticRenderFns = []

export { render, staticRenderFns }